import React, { useEffect } from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import './css/main.css'
import './css/tablet.css'
import './css/mobile.css'
import './css/special.css'
import './css/spinner.css'
import i18n from "./i18n";
import { DataContextProvider } from './dataContext';
import { useDispatch, useSelector } from 'react-redux';
import AnimatedRoutes from './router';
import { fetchVersioningGet } from './redux/slices/versioningGetSlice';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  const { lang } = useSelector((state) => state.lang);
  const dispatch = useDispatch();

  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang]);

  const getData = async () => {
    var data = await dispatch(fetchVersioningGet());
    if (data?.payload) {
      console.log("Version: ", data?.payload?.version);
      if (!localStorage.getItem("version") === null || localStorage.getItem("version") === undefined || localStorage.getItem("version") === "undefined") {
        localStorage.setItem("version", data?.payload?.version)
      }
      if (parseInt(data?.payload?.version) !== parseInt(localStorage.getItem("version"))) {
        localStorage.clear()
        localStorage.setItem("version", data?.payload?.version)
      }
    }
  }

  useEffect(() => { getData() }, [dispatch]);


  return (
    <>
      <DataContextProvider>
        <Router>
          <AnimatedRoutes />
        </Router>
        <ToastContainer />
      </DataContextProvider>
    </>
  );
};

export default App;
